module.exports = __webpack_public_path__ + "img/skillset-gem-4.c6149e1a.png";